export const privateInsuranceImage = "/assets/jpg/privateinsurance.jpg";